export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8103.ecd556d3.jpg";